import { jsxs as _jsxs } from "preact/jsx-runtime";
export function CharCounter({ value, max, className = '', warnAt = 0.8 }) {
    const len = (value ?? '').length;
    const ratio = max > 0 ? len / max : 0;
    const tone = len >= max
        ? 'text-red-600 dark:text-red-400'
        : ratio >= warnAt
            ? 'text-amber-600 dark:text-amber-400'
            : 'text-slate-400 dark:text-slate-500';
    return (_jsxs("div", { "aria-live": "polite", className: `mt-1 text-xs text-right ${tone} ${className}`, children: [len, "/", max] }));
}
